import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import CustomerNotificationsPage from './pages/CustomerNotificationsPage.vue';
import MultiChannelCampaignsPage from './pages/MultiChannelCampaignsPage.vue';
import MultiChannelCampaignDetailPage from './pages/MultiChannelCampaignDetailPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'customer_notifications',
          name: 'campaigns_customer_notifications_index',
          meta: { permissions: ['administrator'] },
          component: CustomerNotificationsPage,
        },
        {
          path: 'multi_channel',
          name: 'campaigns_multi_channel_index',
          meta,
          component: MultiChannelCampaignsPage,
        },
        {
          path: 'multi_channel/:campaignId',
          name: 'campaigns_multi_channel_detail',
          meta,
          component: MultiChannelCampaignDetailPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
